import "./../assets/scss/App.scss";

import * as React from "react";

import { Route, Switch, useHistory } from "react-router-dom";

import { observer } from "mobx-react-lite";
import { hot } from "react-hot-loader";
import LayoutMain from "../Layouts/LayoutMain";
import { Matrix } from "../modules/Admin/Matrix/Matrix";
import MenuCustomizing from "../modules/Admin/MenuCustomizing";
import Roles from "../modules/Admin/roles";
import SessionSettings from "../modules/Admin/System/Session/SessionSettings";
import Users from "../modules/Admin/users";
import LoggingPermissions from "../modules/Logging/LoggingPermissions";
import { CustomDictionary } from "../modules/Nsi/components/CustomDictionary/CustomDictionary";
import CustomDictionaries from "../modules/Nsi/CustomDictionaries";
import NsiSystem from "../modules/Nsi/nsiSystem";
import NsiOrganizations from "../modules/Nsi/organizations/NsiOrganizations";
import OrganizationForm from "../modules/Nsi/organizations/OrganizationForm/OrganizationForm";
import SitPanelReports from "../modules/SitPanel/components/SitPanelReports/SitPanelReports";
import SitAnalytics from "../modules/SitPanel/SitAnalytics";
import SitPanel from "../modules/SitPanel/SitPanel";
import SitReestr from "../modules/SitPanel/SitReestr";
import SentLog from "../modules/Sms/SentLog";
import SmsSettings from "../modules/Sms/SmsSettings";
import RouteSettings from "../modules/SystemSettings/RouteSettings";
import { authStore } from "../store/authStore";
import { AuthPage } from "./AuthPage/AuthPage";
import { ChangePasswordForm } from "./AuthPage/ChangePasswordForm/ChangePasswordForm";
import { ForgotPasswordForm } from "./AuthPage/ForgotPasswordForm/ForgotPasswordForm";
import { ChooseOrganization } from "./AuthPage/LoginForm/ChooseOrganization";
import { LoginForm } from "./AuthPage/LoginForm/LoginForm";
import DefectForm from "./DefectForm";
import SitpanelSetting from "../modules/Admin/System/Sitpanel/SitpanelSetting";
import LoginPage from "../modules/Admin/System/Loginpage/loginpage";
import RsoSettings from "../modules/RsoSettings";
import { LoginEsiaForm } from "./AuthPage/LoginEsia/LoginEsiaForm";
import { LoginEsiaNoEmailForm } from "./AuthPage/LoginEsiaNoEmail/LoginEsiaNoEmailForm";
import DefaultPage from "./DefaultPage";

const App = observer(() => {
  const history = useHistory();
  const searchString = new URLSearchParams(window.location.search);
  const code = searchString.get("code");

  React.useEffect(() => {
    if (!code) authStore.getUserInfo(history);
  }, []);

  return (
    <Switch>
      <Route
        path={[
          "/login-esia",
          "/login-esia-no-email",
          "/login",
          "/reset-password",
          "/change-password",
          "/esia/choose-org",
        ]}
      >
        <AuthPage>
          <Switch>
            <Route path="/login-esia" component={LoginEsiaForm} />
            <Route
              path="/login-esia-no-email"
              component={LoginEsiaNoEmailForm}
            />
            <Route path="/login" component={LoginForm} />
            <Route path="/reset-password" component={ForgotPasswordForm} />
            <Route path="/change-password" component={ChangePasswordForm} />
            <Route path="/esia/choose-org" component={ChooseOrganization} />
          </Switch>
        </AuthPage>
      </Route>

      <LayoutMain>
        <Route path={"/"} exact={true} component={DefaultPage} />
        <Route
          path={"/sp/notif-settings"}
          exact={true}
          component={SmsSettings}
        />
        <Route path={"/sp/notif-history"} exact={true} component={SentLog} />
        <Route path={"/sp/map"} exact={true} component={SitPanel} />
        <Route path={"/sp/reports"} exact={true} component={SitPanelReports} />
        <Route path={"/sp/analytics"} exact={true} component={SitAnalytics} />
        <Route path={"/sp/reestr"} exact={true} component={SitReestr} />
        <Route path={"/sp/reestr/:id"} exact={true} component={SitReestr} />
        <Route
          path={"/sp/defectform/:id/:type(close)?"}
          exact={true}
          component={DefectForm}
        />
        <Route path={"/sp/rso-settings"} exact={true} component={RsoSettings} />
        <Route path={"/nsi/system"} exact={true} component={NsiSystem} />
        <Route
          path={"/nsi/custom"}
          exact={true}
          component={CustomDictionaries}
        />
        <Route
          path={"/nsi/custom/:dictionaryName"}
          exact={true}
          component={CustomDictionary}
        />
        <Route
          path={"/nsi/organizations-and-buildings"}
          exact={true}
          component={NsiOrganizations}
        />
        <Route
          path={"/nsi/organizations/:id/edit"}
          exact={true}
          component={OrganizationForm}
        />
        <Route path={"/admin/users"} exact={true} component={Users} />
        <Route path={"/admin/roles"} exact={true} component={Roles} />
        <Route path={"/admin/menu"} exact={true} component={MenuCustomizing} />
        <Route path={"/admin/matrix"} exact={true} component={Matrix} />
        <Route path={"/admin/system/loginpage"} component={LoginPage} />
        <Route
          path={"/admin/logging/permissions"}
          exact={true}
          component={LoggingPermissions}
        />
        <Route
          path={"/admin/system-settings/routes"}
          exact={true}
          component={RouteSettings}
        />
        <Route path={"/admin/system/session"} component={SessionSettings} />
        <Route path={"/admin/system/sitpanel"} component={SitpanelSetting} />
        <Route path={"/a"} exact={true}>
          <div
            style={{
              padding: "20px",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              flexWrap: "wrap",
            }}
          ></div>
        </Route>
      </LayoutMain>
    </Switch>
  );
});
declare let module: Record<string, unknown>;
export default hot(module)(App);
